import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: theme.palette.primary200,
  },
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    width: "100%",
    minWidth: 300,
    minHeight: 0,
  },
  ephemeralMessageBg: {
    marginTop: 24,
    marginBottom: 18,
    backgroundColor: theme.palette.neutral200,
    borderRadius: theme.radius.radius200,
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "auto",
  },
  ephemeralMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.neutral400,
    padding: "8px 16px",
    flexDirection: "column",
  },

  messagesList: {
    backgroundImage: theme.palette.ticketsBackground,
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    minHeight: 0,
    padding: "20px 20px 20px 20px",
    overflowY: "auto",
    ...theme.scrollbarStyles,
    [theme.breakpoints.down("xs")]: {
      padding: "12px 8px 16px",
    },
  },

  loading: {
    color: theme.palette.primary,
  },
  messageLeft: {
    marginTop: 4,
    height: "auto",
    position: "relative",
    fontSize: "14px",
    display: "block",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.background200,
    color: theme.palette.neutral400,
    alignSelf: "flex-start",
    borderRadius: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "80%",
  },
  viewOnceMessage: {
    marginTop: 4,
    height: "auto",
    position: "relative",
    fontSize: "14px",
    display: "block",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.background200,
    color: theme.palette.neutral300,
    alignSelf: "flex-start",
    borderRadius: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "80%",
  },
  viewOnceMessageRight: {
    marginTop: 4,
    height: "auto",
    position: "relative",
    fontSize: "14px",
    display: "block",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.background300,
    color: theme.palette.neutral300,
    alignSelf: "flex-end",
    borderRadius: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "80%",
  },
  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.palette.background300,
    borderRadius: "12px",
    display: "flex",
    position: "relative",
    alignItems: "center",
    gap: "10px",
    height: "100%",
  },
  quotedMsg: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },
  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },
  audioMessage: {
    display: "flex",
    alignItems: "center",
  },
  scrollButton: {
    opacity: 0.9,
    backgroundColor: theme.palette.primary200,
    borderRadius: theme.radius.radius300,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary300,
    },
    position: "relative",
  },
  newMessagesCount: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    backgroundColor: "#f44336",
    color: "white",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  },
  messageRight: {
    marginTop: 4,
    height: "auto",
    position: "relative",
    fontSize: "14px",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.palette.background300,
    color: theme.palette.neutral400,
    alignSelf: "flex-end",
    borderRadius: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "80%",
  },
  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: "#f0f0f0",
    borderRadius: "12px",
    display: "flex",
    position: "relative",
    alignItems: "center",
    gap: "10px",
    height: "100%",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: "#2391E1",
    fontWeight: 500,
  },

  contactAvatar: {
    width: 24,
    height: 24,
    marginRight: 8,
  },

  groupMessageContactName: {
    color: theme.palette.primary200,
    fontWeight: 500,
  },

  groupContactInfo: {
    display: "flex",
    alignItems: "center",
    marginBottom: 4,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
    minHeight: "18px",
  },

  textContentItemEdited: {
    overflowWrap: "break-word",
    padding: "3px 120px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: theme.palette.neutral300,
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
    textDecoration: "line-through",
  },

  textContentItemDeletedWithoutPermission: {
    fontStyle: "italic",
    color: theme.palette.neutral300,
    overflowWrap: "break-word",
    textDecoration: "line-through",
  },

  messageMedia: {
    background: "black",
    overflow: "hidden",
    objectFit: "contain",
    width: window.innerWidth > 630 ? 340 : 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  timestamp: {
    marginTop: -22,
    paddingBottom: 12,
    fontSize: 12,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    color: "#999",
  },
  erroEntregaAviso: {
    color: theme.palette.feedbackError100,
    fontSize: 12,
    marginLeft: theme.espacamento.spacing200,
    whiteSpace: "nowrap",
  },
  forwardedMessage: {
    fontStyle: "italic",
    fontSize: "12px",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
    marginBottom: 4,
    opacity: 0.7,
  },
  anuncioCtwaCard: {
    overflow: "hidden",
    borderRadius: theme.radius.radius300,
    marginBottom: 4,
    backgroundColor: theme.palette.background300,
  },
  anuncioCtwaFallback: {
    fontStyle: "italic",
    fontSize: "12px",
    fontWeight: 400,
    marginBottom: 4,
    opacity: 0.7,
  },
  dailyTimestamp: {
    marginTop: 24,
    marginBottom: 18,
    backgroundColor: theme.palette.neutral100,
    borderRadius: theme.radius.radius400,
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "auto",
  },
  dailyTimestampText: {
    color: theme.palette.neutral400,
    alignSelf: "center",
    padding: `${theme.espacamento.spacing300} ${theme.espacamento.spacing400}`,
    borderRadius: theme.radius.radius400,
    border: `1px solid ${theme.palette.neutral200}`,
    fontSize: "12px",
  },
  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },
  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },
  ackDoneAllIcon: {
    color: theme.palette.primary300,
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },
  downloadMedia: {
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    backgroundColor: theme.palette.neutral200,
    borderRadius: theme.radius.radius300,
    paddingTop: 10,
    paddingBottom: 10,
  },
  ligacaoEstilo: {
    paddingTop: "8px",
  },
  // Log de chamada (mesmo porte de uma mensagem de texto)
  callSystemRow: {
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    maxWidth: "80%",
    marginTop: 10,
    marginBottom: 6,
  },
  callSystemRowLeft: {
    alignItems: "flex-start",
    alignSelf: "flex-start",
  },
  callSystemRowRight: {
    alignItems: "flex-end",
    alignSelf: "flex-end",
  },
  callSystemPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    maxWidth: "100%",
    minHeight: 40,
    boxSizing: "border-box",
    padding: "8px 16px",
    borderRadius: 12,
    backgroundColor:
      theme.palette.type === "dark" || theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.08)"
        : "rgba(0, 0, 0, 0.06)",
    color: theme.palette.neutral400 || theme.palette.text?.secondary || "#8696a0",
    boxShadow: "none",
  },
  callSystemIcon: {
    flexShrink: 0,
  },
  callSystemIconMissed: {
    color: theme.palette.feedbackError100 || "#ea4335",
  },
  callSystemIconAnswered: {
    color: theme.palette.feedbackSuccess100 || "#25d366",
  },
  callSystemIconOutgoing: {
    color: theme.palette.neutral400 || "#8696a0",
  },
  callSystemText: {
    fontSize: 14,
    lineHeight: 1.4,
    fontWeight: 400,
    textAlign: "left",
  },
  callSystemTime: {
    fontSize: 11,
    opacity: 0.75,
    marginLeft: 4,
    whiteSpace: "nowrap",
    alignSelf: "flex-end",
    paddingBottom: 1,
  },
}))

export default useStyles
